import httpManager from "@/app/shared/utils/httpManager";

export async function getDataLoggedUser() {
  const response = await httpManager.get("/users/data/");
  
  return response.data;
}
